module.exports = __webpack_public_path__ + "static/media/img_mobile_brand_a_device.595deeef.png";